import styles from '@styles/scss/common/_mainTitle.module.scss';
import Link from 'next/link';

export default function MainTitle({
    title,
    siteLink,
    categoryName,
    linkText,
    translation
}: {
    title: string;
    siteLink?: string;
    categoryName?: string;
    linkText?: string;
    translation?: string;
}): JSX.Element {
    return (
        <div className={styles.container}>
            <h1>{title}</h1>
            {siteLink && (
                <Link prefetch={false} href={siteLink}>
                    <a
                        href={siteLink}
                        data-site-name={title}
                        data-site-category={categoryName}
                        className={styles.siteLink}
                        target="_blank"
                        rel="noopener noreferrer">
                        {linkText}
                    </a>
                </Link>
            )}
        </div>
    );
}
